export const DEFAULT_PLUGIN_CONFIG = {
    root: {
        sidePanelRowOrder: ['inputs', 'props', 'classState'],
        globalActionOrder: ['remoteRenderer'],
        globalOrder: ['fixtureSearch', 'notifications'],
        navRowOrder: ['fixtureSearch', 'fixtureBookmarks', 'fixtureTree'],
        fixtureActionOrder: ['bookmarkFixture'],
        rendererActionOrder: ['openFixture', 'fullScreen', 'responsivePreview'],
    },
    inputsPanel: {
        actionOrder: ['expandCollapse'],
    },
};
